module.exports = __webpack_public_path__ + "img/104.de18ce44.jpg";